// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixWindow from 'wix-window';

let lastWindowWidth = 0;
let showgroup = 'size1';
let hidegroup = 'size2';

$w.onReady(function () {

    setInterval(responsifyPage, 100);

});


function responsifyPage(){
wixWindow.getBoundingRect()
.then( (windowSizeInfo) => {
   if(lastWindowWidth !== windowSizeInfo.window.width){
       lastWindowWidth = windowSizeInfo.window.width
        if(wixWindow.formFactor !== "Mobile"){
            if(lastWindowWidth < 1015){$w('#text129').hide();
            }else {$w('#text129').show();}
        }

}});
}